import cx from 'classnames';
import styled from 'styled-components';

import {
  SvgProps,
  PathProps,
  TitleProps,
  MaskProps,
  GContainerProps,
  LineProps,
  PolygonProps,
  CircleProps,
  AnimatedTransformProps,
  ElipseProps,
  RectangleProps
} from './interfaces';

export const Path = styled.path.attrs((props: PathProps) => ({
  d: props.d,
  transition: props.transition,
  fill: props.fill
}))``;

// TODO: FIX the styled component for that
export const AnimatedTransform = styled.div.attrs((props: AnimatedTransformProps) => ({
  attributeName: props.attributeName ?? 'transform',
  type: props.type ?? 'rotate',
  repeatCount: props.repeatCount ?? 'indefinite',
  duration: props.duration ?? '1s',
  from: props.spinFrom ?? '0 18 18',
  to: props.spinTo ?? '360 18 18'
}))<AnimatedTransformProps>``;

export const Polygon = styled.polygon<PolygonProps>``;

export const Title = styled.title<TitleProps>``;

export const Mask = styled.mask<MaskProps>``;

export const G = styled.g<GContainerProps>``;

export const Elipse = styled.ellipse<ElipseProps>``;

export const Circle = styled.circle<CircleProps>``;

export const Line = styled.line<LineProps>``;

export const Rectangle = styled.rect<RectangleProps>``;

export const Svg = styled.svg<SvgProps>`
  ${props => props.cssHelper}
`;
